import axiosInstance from "auth/FetchInterceptor";
import {
  FLIGHT_ROUTE_API,
  GET_ALL_FLIGHT_ROUTE,
  GET_ALL_ACTIVE_FLIGHT_ROUTE,
  CREATE_FLIGHT_ROUTE,
  UPDATE_FLIGHT_ROUTE,
} from "constants/ApiConstant";

const FlightRouteService = {};

FlightRouteService.getAll = function () {
  return axiosInstance.get(GET_ALL_FLIGHT_ROUTE);
};

FlightRouteService.getAllActive = function () {
  return axiosInstance.get(GET_ALL_ACTIVE_FLIGHT_ROUTE);
};

FlightRouteService.createFlightRoute = function (data) {
  return axiosInstance.post(CREATE_FLIGHT_ROUTE, data);
};

FlightRouteService.updateFlightRoute = function (data) {
  return axiosInstance.put(UPDATE_FLIGHT_ROUTE, data);
};

FlightRouteService.deleteFlightRoute = function (id) {
  return axiosInstance.delete(`${FLIGHT_ROUTE_API}/${id}`);
};

export default FlightRouteService;
